"use client";

import React from "react";
import { motion, useReducedMotion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function BookDriver() {
  const shouldReduceMotion = useReducedMotion();
  const ctaUrl = "https://wa.me/201010634627?text=Hello%20Hurghada%20Transfer%20Hub,%20I%20would%20like%20to%20book%20a%20private%20driver.";
  return <section id="bookprivatedrivercta" data-nav="light" className="bg-background text-foreground py-12 md:py-16">
      <div className="max-w-[1136px] mx-auto px-6">
        <motion.div initial={shouldReduceMotion ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        ease: "easeOut"
      }} className="rounded-2xl border border-border bg-secondary text-secondary-foreground p-8 sm:p-12 md:p-14 text-center shadow-xs flex flex-col items-center justify-center gap-6">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-semibold tracking-tight">
            Privaten Fahrer buchen
          </h2>

          <Button asChild size="lg" className="rounded-full bg-[#27BA2A] text-white hover:bg-[#22a025] px-8 h-12 text-base font-medium shadow-sm transition-colors">
            <Link to={ctaUrl} newTab aria-label="Auf WhatsApp anfragen, um einen privaten Fahrer zu buchen">
              <MessageCircle className="size-5 shrink-0" />
              <span>Auf WhatsApp anfragen</span>
            </Link>
          </Button>
        </motion.div>
      </div>
    </section>;
}